const BORDER_SIZE = 1;
const BASE_FONT = 12;
const ITEM_HEIGHT = 32;

export const getItemsHeight = (count: number) => (
    ITEM_HEIGHT * count - (BORDER_SIZE / BASE_FONT) * count
);
